import axios from 'axios';

const createAutomation = () => {
    return axios.get('/automations/new');
};

const deleteAutomation = (id) => {
    return axios.delete(`/automations/flows/${id}`);
};

const disableAutomation = (id) => {
    return axios.patch(`/automations/flows/${id}/disable`);
};

const duplicateAutomation = (id, formData = {}) => {
    return axios.post(`/automations/flows/${id}/duplicate`, formData);
};

const enableAutomation = (id) => {
    return axios.patch(`/automations/flows/${id}/enable`);
};

const getAutomations = () => {
    return axios.get('/automations/flows');
};

const getAutomationTemplates = () => {
    return axios.get('/automations/flow-templates');
};

const useAutomationTemplate = (id, formData = {}) => {
    return axios.post(`/automations/flow-templates/${id}/use`, formData);
};

const updateAutomation = (id, formData = {}) => {
    return axios.post(`/automations/flows/${id}/update`, formData);
};

const getAutomationPieces = (pieceNames) => {
    return axios.post('/automations/pieces', {
        pieces: pieceNames,
    });
};

const getPipelines = async () => {
    const allPipelines = await ApiClient.fetchAllGet('/opportunities/pipelines');
    return {
        data: allPipelines,
    };
};

const getPipelineSteps = async (pipelineId) => {
    const allSteps = await ApiClient.fetchAllGet(`/opportunities/pipelines/${pipelineId}/steps`);
    return {
        data: allSteps,
    };
};

const getStaffs = async () => {
    const allStaffs = await ApiClient.fetchAllGet('/staffs');
    return {
        data: allStaffs,
    };
};

const renameAutomationFlow = (id, formData = {}) => {
    return axios.post(`/automations/flows/${id}/rename`, formData);
};

const getTaskLabels = async () => {
    const allLabels = await ApiClient.fetchAllGet(`/tasks/labels`);
    return {
        data: allLabels,
    };
};

const getOpportunitySources = async () => {
    const allSources = await ApiClient.fetchAllGet('/opportunities/sources');
    return {
        data: allSources,
    };
};

export {
    createAutomation,
    deleteAutomation,
    disableAutomation,
    duplicateAutomation,
    enableAutomation,
    getAutomations,
    getAutomationPieces,
    getAutomationTemplates,
    getPipelines,
    getPipelineSteps,
    getStaffs,
    getTaskLabels,
    getOpportunitySources,
    renameAutomationFlow,
    updateAutomation,
    useAutomationTemplate,
};
